import { useEffect, useMemo, useState } from 'react';
import { Header, Section } from '../../shared/components';
import { getSettingsRepository } from '../../shared/services/settings/repositoryFactory';
import { ParamActivity, ParamUser } from '../../shared/services/settings/types';
import { ReportFilters } from '../../shared/services/reports/types';
import { ReportsFilters } from './components/ReportsFilters';
import { ActivityKpiPanel } from './components/ActivityKpiPanel';
import { UserKpiPanel } from './components/UserKpiPanel';
import { NovedadKpiPanel } from './components/NovedadKpiPanel';

const settingsRepo = getSettingsRepository();

/**
 * Modulo: Reportes (KPIs). 3 paneles con boton de ocultar/mostrar cada uno,
 * filtros compartidos y paginador graduable (5/10/15) dentro de cada panel.
 */
export function ReportsPage() {
  const [activities, setActivities] = useState<ParamActivity[]>([]);
  const [users, setUsers] = useState<ParamUser[]>([]);
  const [filters, setFilters] = useState<ReportFilters>({});

  useEffect(() => {
    settingsRepo.listActivities().then(setActivities);
    settingsRepo.listUsers().then(setUsers);
  }, []);

  // El input de fecha solo da "YYYY-MM-DD" (fecha local, sin hora). El Worker
  // corre siempre en UTC, asi que aqui se resuelve la hora LOCAL del navegador
  // y se convierte a un instante UTC explicito antes de mandarlo al backend
  // (evita el mismo desfase horario que afectaba el historial de Tiempos).
  const effectiveFilters = useMemo<ReportFilters>(
    () => ({
      ...filters,
      dateFrom: filters.dateFrom ? new Date(`${filters.dateFrom}T00:00:00`).toISOString() : undefined,
      dateTo: filters.dateTo ? new Date(`${filters.dateTo}T23:59:59.999`).toISOString() : undefined,
    }),
    [filters]
  );

  return (
    <div>
      <Header title="Reportes" subtitle="Indicadores de Control de Tiempos Operativos" />
      <div className="space-y-6 p-4">
        <Section title="Filtros">
          <ReportsFilters value={filters} onChange={setFilters} users={users} activities={activities} />
        </Section>

        <div className="space-y-4">
          <ActivityKpiPanel filters={effectiveFilters} />
          <UserKpiPanel filters={effectiveFilters} />
          <NovedadKpiPanel filters={effectiveFilters} />
        </div>
      </div>
    </div>
  );
}
